export const Create_dossier = 291;
export const Rename_dossier = 292;
export const Add_doc = 293;
export const Delete = 294;
